module.exports = __webpack_public_path__ + "static/media/statics_prevclassroom.50f53068.jpg";